import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import { PAGE_URL } from "../services/constant";

const ApiKeyPermissionGroupMapping = React.lazy(() =>
    import('../ApiKeyPermissionGroupMapping')
);

const apiKeyPermissionGroupMappingRoutesRegistry = [
    {
        path: PAGE_URL.API_KEY_PERMISSION_GROUP_MAPPING_PAGE,
        element: <ApiKeyPermissionGroupMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiKeyPermissionGroupMappingRoutesRegistry;
